var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAurora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAurora0)",
    d: "M13.346 6.84a1.5 1.5 0 0 0-2.692 0l-4.063 7.701a1.5 1.5 0 0 0 1.346 2.173h8.126a1.5 1.5 0 0 0 1.346-2.173zm-3.459-.386a2.357 2.357 0 0 1 4.226 0l4.067 7.702a2.356 2.356 0 0 1-2.117 3.415H7.937a2.366 2.366 0 0 1-2.117-3.415l4.067-7.697z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAurora0",
    x1: 15.995,
    x2: 8.381,
    y1: 6.496,
    y2: 16.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95E141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#63B836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#409C2D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurora);
export default __webpack_public_path__ + "static/media/aurora.9b9e4c9d0ad6c4f3dae3cddf19ffdbbc.svg";
export { ForwardRef as ReactComponent };